module.exports = __webpack_public_path__ + "img/theroom_guitars_thumb.13f62332.jpg";